import { useRecoilValue } from "recoil";
import { useConfig } from "src/hooks/config";
import upperDataStore from "src/stores/upperData";
import { calculateAmountRate } from "calculation";
import { getAmountWithCurrency } from "../helpers/view";

interface IProps {
    amount: number;
};

const Money = ({ amount }: IProps) => {
    const config = useConfig();
    const { currencyConfig } = useRecoilValue(upperDataStore);

    return <>
        {getAmountWithCurrency(amount, config, currencyConfig)}
        {config.showAdditionalCoin && currencyConfig && <span className="B-additional-currency">{`/ ${calculateAmountRate(amount, config, currencyConfig)} ${config.currencySymbol[config.additionalCoinMap[currencyConfig.name]]}`}</span>}
    </>;
};

export default Money;